/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWeekDayNames;
var _moment = _interopRequireDefault(require("moment"));
var DEFAULT_WEEK_START_DAY = (0, _moment.default)().startOf('week').format('d') * 1;
function getWeekDayNames(startDay, locale) {
  var weekDays;
  if (locale) {
    var data = _moment.default.localeData(locale);
    weekDays = data && data._weekdaysShort ? data._weekdaysShort : weekDays;
  }
  weekDays = (weekDays || _moment.default.weekdaysMin()).concat();
  var names = weekDays;
  var index = startDay == null ? DEFAULT_WEEK_START_DAY : startDay;
  while (index > 0) {
    names.push(names.shift());
    index--;
  }
  return names;
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/utils/getWeekDayNames.js
// module id = 661
// module chunks = 0